import React from 'react';
import { Check } from 'lucide-react';
export function HighlightBox() {
  const benefits = ['Solves the Permeability Wall problem that makes regular skincare ineffective after menopause', 'Clinical-grade ingredients delivered directly into the dermal layer where aging happens', 'Visible results in just one hour with improvement over time', 'Replaces expensive dermatologist visits with at-home convenience', '5 minutes, once a month—actually fits into real life', '30-day money-back guarantee—zero risk to try'];
  return <div className="bg-pink-50 border-2 border-pink-300 rounded-lg p-8 space-y-4" data-id="element-199">
      <h3 className="text-2xl font-bold text-center text-gray-900" data-id="element-200">
        Why Women Over 50 Love This Micro-Infusion Device:
      </h3>
      <ul className="space-y-3" data-id="element-201">
        {benefits.map((benefit, index) => <li key={index} className="flex gap-3" data-id="element-202">
            <Check className="w-6 h-6 text-pink-600 flex-shrink-0 mt-1" data-id="element-203" />
            <span className="text-lg text-gray-800" data-id="element-204">{benefit}</span>
          </li>)}
      </ul>
    </div>;
}